import { Customer } from "./customer";
import { Dealer } from "./dealer";

export class DormantFeedback {
    _id: string;
    customer: Customer;
    dealer: Dealer;
    mauticId: string;
    forgotBooking: boolean;
    carSold: boolean;
    moved: boolean;
    carWorkshop: boolean;
    customerService: boolean;
    price: boolean;
    message: string;
    handled: boolean;
    note: string;
    createdAt: Date;
    updatedAt: Date;
}


// WEBPACK FOOTER //
// ./src/app/_models/dormantFeedback.ts